<span *ngIf="showName" istag="nameLabel">{{formControlName.value}}</span>
<label class="material-icons" istag="uploadBtn">
  <input
    type="file"
    [accept]="accept"
    (change)="getImg($event)"
    capture="user"
  />{{ icon }}
</label>
